namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;
    
    export interface IEmailRequest {
		senderName: string;
		senderAddress: string;
		recipientFirstName: string;
		recipientLastName: string;
		recipientAddress: string;
		templaterName: string;
		parameters: string;
    }

	export class EmailRequest implements IEmailRequest {
		senderName: string;
		senderAddress: string;
		recipientFirstName: string;
		recipientLastName: string;
		recipientAddress: string;
		templaterName: string;
		parameters: string;

		constructor(obj?: IEmailRequest) {
			this.senderName = null;
			this.senderAddress = null;
			this.recipientFirstName = null;
			this.recipientLastName = null;
			this.recipientAddress = null;
			this.templaterName = null;
			this.parameters = null;

            if (obj) {
				this.senderName = obj.senderName;
				this.senderAddress = obj.senderAddress;
				this.recipientFirstName = obj.recipientFirstName;
				this.recipientLastName = obj.recipientLastName;
				this.recipientAddress = obj.recipientAddress;
				this.templaterName = obj.templaterName;
				this.parameters = obj.parameters;
            }
        }
    }
}
